// Used by both the island in the app layout and the inner of the header
export const islandContainerClasses = "mx-auto max-w-full md:max-w-4xl lg:max-w-6xl xl:max-w-[90rem] container px-4";
